import { sweep } from '@Guidelines/Theme/helpers/animations';
import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const trackStyle = css`
	width: 100%;
	max-width: 20rem;
	height: 6px;
	border-radius: ${theme.radii.pill};
	background-color: ${theme.colors.track};
	overflow: hidden;
`;

const fillStyle = css`
	width: 40%;
	height: 100%;
	border-radius: ${theme.radii.pill};
	background: linear-gradient(90deg, #6fbfd2, ${theme.colors.waveform});
	animation: ${sweep} 1.6s ease-in-out infinite;

	@media (prefers-reduced-motion: reduce) {
		animation: none;
	}
`;

/** Indeterminate bar of a document being generated: a light-cyan to amber gradient sweeping the track. */
const GenerationSweepBar: React.FC = () => {
	return (
		<div css={trackStyle} role="progressbar" aria-label="Génération en cours">
			<div css={fillStyle} />
		</div>
	);
};

export default GenerationSweepBar;
